<form :action="action" method="post"><input :value="csrfToken" name="authenticity_token" type="hidden"><slot></slot></form>